import React from "react";
import { Image } from "./image";
import { usePublicGallery } from "../hooks/useGallery";

export const Gallery = () => {
  const { photos, isGalleryLoading } = usePublicGallery();

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Gallery</h2>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {isGalleryLoading ? (
              <p>Loading...</p>
            ) : photos.length > 0 ? (
              photos.map((photo, i) => (
                <div key={photo._id || i} className="col-sm-6 col-md-4 col-lg-4">
                  <Image
                    title="View Full Image"
                    largeImage={photo.url}
                    smallImage={photo.url}
                  />
                </div>
              ))
            ) : (
              <p style={{ color: "#777" }}>No photos available.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

